import { Store } from '@ngrx/store';
import { resetErrorMessage, setErrorMessage, } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
import { createMetricAlert } from 'AlertsApp/ts/features/alerts-modals/state/metric-alert-items/metric-alert-items.actions';
import { ALERTS_INDICATOR_FIELD_OPTIONS_CONFIG, ALERTS_INDICATOR_VALUE, ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE, ALERTS_OPERATOR_CONFIG, METRIC_ALERT_LIMIT, } from 'AlertsApp/ts/features/alerts-modals/constants';
import { AlertsService } from 'AlertsApp/ts/services/alerts.service';
import * as i0 from "@angular/core";
import * as i1 from "AlertsApp/ts/services/alerts.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-secondary btn-block dropdown-toggle style-underline" });
const _c1 = a0 => ({ disabled: a0 });
/**
 * IndicatorAlertParamsComponent.
 *
 * Indicator alert modal section to register a new metrics alerts.
 *
 * Input Properties:
 * alertObject: Object that represents a Watchlist for the indicator Alerts modal.
 *
 * Output properties:
 *  createHandler: object that represents the params to create a new Alert
 */
export class IndicatorAlertParamsComponent {
    constructor(alertsService, store) {
        this.alertsService = alertsService;
        this.store = store;
        this.field = ALERTS_INDICATOR_VALUE;
        this.fieldOptions = ALERTS_INDICATOR_FIELD_OPTIONS_CONFIG;
        this.operator = ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE;
        this.operatorOptions = ALERTS_OPERATOR_CONFIG;
        this.limitValue = null;
    }
    /**
     * Handler for the field dropdown menu.
     *
     * @param field: Selected field.
     */
    fieldHandler(field) {
        this.field = field;
    }
    /**
     * Handler for the operator dropdown menu.
     *
     * @param operator: Selected operator.
     */
    operatorHandler(operator) {
        this.operator = operator;
    }
    /**
     * Resets the values for the modal.
     */
    resetAlertState() {
        this.field = ALERTS_INDICATOR_VALUE;
        this.operator = ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE;
        this.limitValue = null;
    }
    /**
     * Handler for the submit button. Validates that the action can be executed and then emits `createHandler` to perform
     * the creation.
     */
    alertSubmitHandler() {
        // If the user hasn't filled in a limitValue, clicking should do nothing
        if (this.limitValue === null) {
            return;
        }
        const alertMetricParams = {
            calculation: this.field,
            limitType: this.operator,
            limitValue: this.limitValue,
        };
        this.createMetricAlert(alertMetricParams);
    }
    /**
     * Creates a new alert based on a AlertMetricParams object and the current object.
     * Dispatches `createMetricAlert` to add the new alert to the state.
     *
     * @param alertMetricParams: Params for the alert to be created.
     */
    createMetricAlert(alertMetricParams) {
        this.alertsService
            .createAlert(METRIC_ALERT_LIMIT, this.alertObject.type, this.alertObject.id, alertMetricParams)
            .subscribe({
            next: (createAlert) => {
                this.store.dispatch(createMetricAlert({ alert: createAlert.alert }));
                this.store.dispatch(resetErrorMessage());
                this.resetAlertState();
            },
            error: () => {
                this.store.dispatch(setErrorMessage({
                    errorMessage: 'Alert creation failed. Please refresh the page or contact support.',
                }));
                this.resetAlertState();
            },
        });
    }
}
IndicatorAlertParamsComponent.ɵfac = function IndicatorAlertParamsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicatorAlertParamsComponent)(i0.ɵɵdirectiveInject(i1.AlertsService), i0.ɵɵdirectiveInject(i2.Store)); };
IndicatorAlertParamsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IndicatorAlertParamsComponent, selectors: [["ycn-indicator-alert-params"]], inputs: { alertObject: "alertObject" }, standalone: false, decls: 18, vars: 12, consts: [[1, "form-row", "row"], [1, "col-4", "form-row"], [1, "form-label", "form-label-thin", "form-row"], [3, "changeHandler", "customCssClasses", "selectedValue", "config"], [1, "col-2", "form-row"], ["type", "number", "placeholder", "Enter Value", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], ["data-test-id", "indicator-alert-params-submit-button", 1, "col-2", "form-row", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "ngClass"]], template: function IndicatorAlertParamsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Target Field");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-single-select-dropdown", 3);
        i0.ɵɵlistener("changeHandler", function IndicatorAlertParamsComponent_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { return ctx.fieldHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 2);
        i0.ɵɵtext(7, "Operator");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-single-select-dropdown", 3);
        i0.ɵɵlistener("changeHandler", function IndicatorAlertParamsComponent_Template_ycn_single_select_dropdown_changeHandler_8_listener($event) { return ctx.operatorHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 1)(10, "div", 2);
        i0.ɵɵtext(11, "NUMBER");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "input", 5);
        i0.ɵɵtwoWayListener("ngModelChange", function IndicatorAlertParamsComponent_Template_input_ngModelChange_12_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.limitValue, $event) || (ctx.limitValue = $event); return $event; });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 6);
        i0.ɵɵlistener("click", function IndicatorAlertParamsComponent_Template_div_click_13_listener() { return ctx.alertSubmitHandler(); });
        i0.ɵɵelementStart(14, "div", 2);
        i0.ɵɵtext(15, "\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 7);
        i0.ɵɵtext(17, " Create ");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(8, _c0))("selectedValue", ctx.field)("config", ctx.fieldOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(9, _c0))("selectedValue", ctx.operator)("config", ctx.operatorOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵtwoWayProperty("ngModel", ctx.limitValue);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.limitValue === null));
    } }, dependencies: [i3.NgClass, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.NgModel, i5.SingleSelectDropdownComponent], encapsulation: 2 });
